export default {
    // eslint-disable-next-line require-jsdoc
    data() {
        return {
            siteTitle: null,
        };
    },
    watch: {
        $route: {
            /**
             * Sets document title and site title
             *
             * @param   {object}  to  Route being navigated.
             */
            handler(to) {
                document.title = `${to.meta.title} | Fusebox`;
                this.siteTitle = to.meta.title;
            },
            immediate: true,
        },
    },
};
